// ══════════════════════════════════════════════════════════════
// COMPASS – User State Model
// ══════════════════════════════════════════════════════════════
import { AuthUser } from '../../models/auth-user.model';

// Re-export AuthUser as User for convenience
export type User = AuthUser;

export interface UserState {
  user: User | null;
  isAuthenticated: boolean;
  isInitialized: boolean;
  tokenExpiresAt: number | null;
  refreshTokenExpiresAt: number | null;
  error: string | null;
}

export const initialUserState: UserState = {
  user: null,
  isAuthenticated: false,
  isInitialized: false,
  tokenExpiresAt: null,
  refreshTokenExpiresAt: null,
  error: null,
};
